import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconTeamsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 20.8227,
			cy: 13.8213,
			r: 3.81115,
			stroke: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6766 25.9898H15.3053C15.3241 25.2853 15.377 24.2815 15.4613 23.3244C15.5149 22.7167 15.5803 22.1364 15.6561 21.6686C15.6941 21.4344 15.7335 21.2351 15.7736 21.0779C15.8162 20.9109 15.851 20.8262 15.8672 20.7978C16.0437 20.4879 16.4061 20.2055 16.9345 19.9649C17.4538 19.7285 18.0754 19.5586 18.6874 19.4388C19.2964 19.3196 19.8778 19.2532 20.3084 19.2167C20.5232 19.1986 20.6991 19.1879 20.8206 19.1819C20.8813 19.1788 20.9283 19.177 20.9596 19.1758L20.9932 19.1747L21.0267 19.1758C21.0581 19.177 21.1051 19.1788 21.1658 19.1819C21.2872 19.1879 21.4632 19.1986 21.6779 19.2167C22.1085 19.2532 22.69 19.3196 23.2989 19.4388C23.911 19.5586 24.5326 19.7285 25.0519 19.9649C25.5803 20.2055 25.9427 20.4879 26.1192 20.7978C26.1353 20.8261 26.17 20.9106 26.2125 21.0776C26.2524 21.2347 26.2917 21.434 26.3295 21.6682C26.4048 22.136 26.4697 22.7162 26.5227 23.324C26.6061 24.281 26.6582 25.285 26.6766 25.9898Z",
			stroke: "#F9BDFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 14.9933,
			cy: 13.8213,
			r: 4.31115,
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.9923,
			cy: 13.8213,
			r: 3.81115,
			fill: "#FFF4FF",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6948 25.9898H9.32357C9.34231 25.2853 9.39526 24.2815 9.47957 23.3244C9.53311 22.7167 9.59857 22.1364 9.67437 21.6686C9.71232 21.4344 9.75178 21.2351 9.79185 21.0779C9.83442 20.9109 9.86925 20.8262 9.88542 20.7978C10.062 20.4879 10.4243 20.2055 10.9527 19.9649C11.472 19.7285 12.0936 19.5586 12.7057 19.4388C13.3146 19.3196 13.8961 19.2532 14.3267 19.2167C14.5414 19.1986 14.7174 19.1879 14.8388 19.1819C14.8995 19.1788 14.9465 19.177 14.9779 19.1758L15.0114 19.1747L15.045 19.1758C15.0763 19.177 15.1233 19.1788 15.184 19.1819C15.3055 19.1879 15.4814 19.1986 15.6962 19.2167C16.1268 19.2532 16.7082 19.3196 17.3172 19.4388C17.9292 19.5586 18.5508 19.7285 19.0702 19.9649C19.5985 20.2055 19.9609 20.4879 20.1374 20.7978C20.1535 20.8261 20.1883 20.9106 20.2307 21.0776C20.2707 21.2347 20.31 21.434 20.3477 21.6682C20.4231 22.136 20.488 22.7162 20.5409 23.324C20.6244 24.281 20.6764 25.285 20.6948 25.9898Z",
			fill: "#FFF4FF",
			stroke: "#C948D8"
		})
	]
});
export default SvgNaviconTeamsActive;
